import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { NutritionBlockType } from '../../models/block';
import type { NutritionBlockData } from '../../models/nutritionBlockData';

type Props = {
  enabled?: boolean;
  suspectIdentificationOrUserBlockId: string;
  userId: string;
};

export const useSuspectIdentification = ({
  enabled = true,
  suspectIdentificationOrUserBlockId,
  userId,
}: Props) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchSuspectIdentification = async (): Promise<
    NutritionBlockData<NutritionBlockType.IdentifySuspectTriggerFoods>
  > => {
    return await api({
      route: `/private/dashboard/user/${userId}/suspect-identification/${suspectIdentificationOrUserBlockId}`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<
    NutritionBlockData<NutritionBlockType.IdentifySuspectTriggerFoods>,
    Error
  >({
    queryKey: [
      'suspect-identification',
      userToken,
      userId,
      suspectIdentificationOrUserBlockId,
    ],
    queryFn: fetchSuspectIdentification,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!suspectIdentificationOrUserBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    suspectIdentification: data ?? null,
    isLoading,
    isError,
  };
};
